import script from "./GiftForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftForm.vue?vue&type=script&setup=true&lang=js"

import "./GiftForm.vue?vue&type=style&index=0&id=8acdaf1e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8acdaf1e"]])

export default __exports__